import Button from "components/Button";
import ImageSlider from "components/ImageSlider";
import Link from "components/Link";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { config } from "config";
import { memo } from "react";
import theme from "theme";
import * as Styled from "../shared";
import { ForgotPasswordLink } from "./Login.styled";
import { useLogin } from "./useLogin";

const Login = memo(() => {
    const {
        inputs,
        inputErrors,
        isLoading,
        onSubmit,
        handleInputChange,
        isFetchingProfileData,
    } = useLogin();

    return (
        <Styled.Wrapper>
            <Styled.LeftWrapper>
                <Styled.Card>
                    <Text variant="heading5" align="center" fullWidth>
                        Login
                    </Text>
                    <Styled.Form onSubmit={onSubmit}>
                        <TextInput
                            name="email"
                            type="email"
                            label="Email"
                            required
                            placeholder="user@email.com"
                            fullWidth
                            labelColor={theme.colors.text}
                            value={inputs.email}
                            onChange={handleInputChange}
                            errorMsg={inputErrors.email}
                            disabled={isLoading}
                        />
                        <TextInput
                            name="password"
                            type="password"
                            label="Password"
                            required
                            placeholder="********"
                            fullWidth
                            labelColor={theme.colors.text}
                            value={inputs.password}
                            onChange={handleInputChange}
                            errorMsg={inputErrors.password}
                            disabled={isLoading}
                        />
                        <ForgotPasswordLink href="/forgot-password">
                            Forgot password?
                        </ForgotPasswordLink>
                        {/* <Checkbox
                            size="XS"
                            fullWidth
                            label="Remember Me"
                            labelColor={theme.colors.text}
                            disabled={isLoading}
                        /> */}
                        <Button
                            type="submit"
                            variant="filled"
                            fullWidth
                            textColor={theme.colors.white}
                            textVariant="button2"
                            isLoading={isLoading || isFetchingProfileData}
                        >
                            Login
                        </Button>
                    </Styled.Form>
                    <Text
                        variant="label"
                        color="#BDBDBD"
                        align="center"
                        fullWidth
                    >
                        I don't have an account.{"  "}
                        <Link
                            href="/sign-up"
                            variant="label"
                            underline
                            color={theme.colors.text}
                        >
                            Sign Up
                        </Link>
                    </Text>
                    {/* <Styled.Hr /> */}
                    {/* <Text
                        variant="label"
                        color="#BDBDBD"
                        fullWidth
                        align="center"
                    >
                        or login with
                    </Text> */}
                </Styled.Card>
                <Styled.CompanyNameContainer>
                    <Styled.CompanyName
                        href="https://www.strydden.com/"
                        target="_blank"
                    >
                        Made with &#9829; by Strydden
                    </Styled.CompanyName>
                </Styled.CompanyNameContainer>
            </Styled.LeftWrapper>
            <Styled.RightWrapper>
                <ImageSlider sliderImages={config.sliderImages} />
            </Styled.RightWrapper>
        </Styled.Wrapper>
    );
});

export default Login;
